import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import Nav from "./Nav";
import axios from "axios";
import PageTransition from "./PageTransition";
import { fetchSingleCrypto } from "../actions/authActions";
import {
  FaSearch,
  FaSortDown,
  FaDollarSign,
  FaHammer,
  FaExclamationTriangle,
  FaTimes,
} from "react-icons/fa";
import pageTransition from "../utils/pageTransition";
import { ResponsiveLine } from "@nivo/line";
var cryptoData = require("./data/CRYPTO.json");

class SearchCrypto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      results: {},
      loading: false,
      message: "",
      mobile: false,
      search: true,
      cryptoSymbol: "",
      cryptoName: "",
      currentPrice: "",
      enterpriseValue: "",
      pe: "",
      outstandingShares: "",
      eps: "",
      recommendationKey: "",
      historicData: "",
      graphData: [],
      graph: false,
      error: false,
      shareCount: 0,
    };
  }

  handleResize = (e) => {
    $(".menu").css("display", "block");
    $(".dropdown").css("flex-direction", "column");
  };

  componentDidMount = () => {
    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false, modal: false });
    }
    $(window).resize(() => {
      this.handleResize();
    });
  };

  handleOnInputChange = (event) => {
    const query = event.target.value;
    if (!query) {
      this.setState({
        query,
        results: [],
      });
    } else {
      this.setState({ query });
    }
  };

  renderSearchResults = () => {
    const { results } = this.state;
    if (Object.keys(results).length && results.length) {
      return (
        <div className="results-container">
          {results.map((result) => {
            return (
              <a
                key={result.id}
                href={result.previewURL}
                className="result-items"
              ></a>
            );
          })}
        </div>
      );
    }
  };

  fetchData = (sym, name, renderDataPage) => {
    $(".crypto-loader").fadeIn("fast");
    this.props.fetchSingleCrypto(sym);
    this.renderDataPage(sym, name);
  };

  renderDataPage = (sym, name) => {
    setTimeout(() => {
      $(".crypto-loader").fadeOut("fast");
      if (this.props.activity.activity.isFetching == false) {
        this.setState({ error: true, search: false });
      } else {
        this.setState({
          search: false,
          cryptoName: name,
          cryptoSymbol: sym,
          error: false,
        });
        if (this.state.error == false) {
          setTimeout(() => {
            $(".data-list").css("opacity", "0.3");
            $(".graph").css("opacity", "0.3");
            $(".price-loader").fadeIn("fast");
            $(".graph-loader").fadeIn("fast");
          }, 100);
          setTimeout(() => {
            // init arrays
            var dates = this.props.activity.activity.indexes[1].result[0]
              .timestamp;
            var prices = this.props.activity.activity.indexes[1].result[0]
              .indicators.quote[0].close;
            // chop to hundredths
            for (var i = 0; i < prices.length; i++) {
              prices[i] = prices[i].toFixed(2);
            }
            // convert to string and fix dates for unix time
            var datesString = dates.map(String);
            for (var i = 0; i < datesString.length; i++) {
              datesString[i] = datesString[i] + "000";
            }
            // convert back to int
            var datesInt = datesString.map(Number);
            // convert to usable date format and chop off time of day
            var actualDates = datesInt.map((elem) =>
              new Date(elem).toISOString()
            );
            for (var i = 0; i < actualDates.length; i++) {
              actualDates[i] = actualDates[i].substr(0, 10);
            }
            // for (var i = 0; i < actualDates.length; i++) {
            //   actualDates[i] = actualDates[i]
            //     .replace(/[-]/g, " ")
            //     .replace(/\s/g, "");
            // }
            // actualDates = actualDates.map(Number);
            console.log(actualDates);
            prices = prices.map(Number);

            function buildData() {
              var xAxis = [];
              for (var i = 0; i < 160; i++) {
                xAxis.push(i);
              }
              var xyData = [];
              for (var i = 0; i < prices.length; i++) {
                xyData.push({ x: xAxis[i], y: prices[i] });
              }
              return xyData.slice(Math.max(xyData.length - 60, 1));
            }
            let graphData = [
              {
                id: this.state.cryptoSymbol,
                color: "rgb(0, 0, 0)",
                data: buildData(),
              },
            ];
            // let graphData = [];
            // for (var i = 0; i < prices.length; i++) {
            //   graphData.push({ [this.state.cryptoSymbol]: [prices[i]] });
            // }

            this.setState({ graphData: graphData });
            console.log(this.state.graphData);
            console.log(this.state.staticData);

            var pe =
              this.props.activity.activity.indexes[0].apiData[0].currentPrice
                .raw /
              this.props.activity.activity.indexes[0].apiData[8].trailingEps
                .raw;
            pe = pe.toFixed(2);
            this.setState({
              currentPrice: this.props.activity.activity.indexes[0].apiData[0]
                .currentPrice.fmt,
              enterpriseValue: this.props.activity.activity.indexes[0]
                .apiData[8].enterpriseValue.fmt,
              outstandingShares: this.props.activity.activity.indexes[0]
                .apiData[8].sharesOutstanding.fmt,
              eps: this.props.activity.activity.indexes[0].apiData[8]
                .trailingEps.fmt,
              pe: pe,
              reccKey: this.props.activity.activity.indexes[0].apiData[0]
                .recommendationKey,
              graph: true,
            });
            $(".data-list").css("opacity", "1");
            $(".price-loader").fadeOut("fast");
            $(".graph").css("opacity", "1");
            $(".graph-loader").fadeOut("fast");
          }, 1000);
        }
      }
    }, 2000);
  };

  renderSearch = () => {
    this.props.activity.activity.isFetching = false;
    this.setState({
      search: true,
      currentPrice: "",
      enterpriseValue: "",
      outstandingShares: "",
      eps: "",
      pe: "",
      reccKey: "",
      graphData: "",
      graph: false,
      error: false,
      cryptoName: "",
      cryptoSymbol: "",
    });
  };

  slideNav = () => {
    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      if ($(".dropdown.search").hasClass("collapsed")) {
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".dropdown.search").css("overflow-x", "hidden");
        $(".search-filter-arrow").css("transform", "rotate(180deg)");
        $(".search-filter-arrow").css("top", "10px");
        $(".dropdown.search").removeClass("collapsed");
        $(".dropdown.search").css("display", "flex");
      } else {
        $(".dropdown.search").addClass("collapsed");
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".search-filter-arrow").css("transform", "rotate(0deg)");
        $(".search-filter-arrow").css("top", "2px");
      }
    } else {
      if ($(".dropdown.search").hasClass("collapsed")) {
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".search-filter-arrow").css("transform", "rotate(180deg)");
        $(".search-filter-arrow").css("top", "7px");
        $(".dropdown.search").removeClass("collapsed");
        $(".dropdown.search").css("display", "flex");
      } else {
        $(".dropdown.search").addClass("collapsed");
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".search-filter-arrow").css("transform", "rotate(0deg)");
        $(".search-filter-arrow").css("top", "-4px");
      }
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  addShares = (sym, name, amount) => {
    var shareCount = Number(amount);
    var crypto = {
      crypto: [
        {
          symbol: sym,
          name: name,
          amount: shareCount,
        },
      ],
    };
    console.log(crypto);
    let id = this.props.activity.auth.user.id;
    axios
      // .post(`http://localhost:3005/api/cryptos/${id}/crypos`, crypto)
      .post(
        `https://trend-backend.herokuapp.com/api/cryptos/${id}/crypos`,
        crypto
      )
      .then((res) => {
        console.log(res);
      });
  };

  showModal = () => {
    if (this.state.modal) {
      this.setState({ modal: false });
      $(".shares-modal-wrapper").fadeOut("fast");
    } else {
      this.setState({ modal: true });
      $(".shares-modal-wrapper").fadeIn("fast");
    }
  };

  render() {
    const { query } = this.state;
    var results;
    results = cryptoData.Cryptos.filter((data) => {
      if (query == "");
      else if (
        data.symbol.toLowerCase().includes(query.toLowerCase()) ||
        data.name.toLowerCase().includes(query.toLowerCase())
      ) {
        return data;
      }
    });

    return (
      <div className="crypto-page-container">
        <div className="crypto-loader">
          <div className="loader">Loading...</div>
        </div>
        <PageTransition />
        <Nav />
        {this.state.search ? (
          <div className="search-wrapper">
            <h2 className="heading">Find Cryptocurrencies</h2>
            <p className="desc">
              Easily search through all publicly traded cryptocurrencies
            </p>
            <div className="search-cont">
              <div className="search-bar">
                <label className="search-label" htmlFor="search-input">
                  <input
                    type="text"
                    name="query"
                    value={query}
                    id="search-input"
                    placeholder="Search..."
                    onChange={this.handleOnInputChange}
                    autoComplete="off"
                  />
                  <FaSearch className="search-icon" />
                </label>
              </div>
              <div className="results-wrapper">
                <div className="search-results">
                  <ul>
                    {results.slice(0, 10).map((data) => {
                      return (
                        <li
                          key={data.symbol}
                          className="result"
                          onClick={() => this.fetchData(data.symbol, data.name)}
                        >
                          <span className="symbol">{data.symbol}</span>
                          <span className="name">{data.name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="crypto-wrapper">
            {this.state.error ? (
              <div className="error-page">
                <div className="error-cont">
                  <FaExclamationTriangle className="error" />
                  <div className="error-text">
                    {/* <h2>Oops! Cryptocurrency data not found.</h2> */}
                    <h2>CRYPTO TRACKING COMING SOON</h2>
                    {/* <p>
                      The company you were searching for probably does not exist
                      or is not publicly traded.
                    </p> */}
                    <p>
                      This feature is currently under construction, check back
                      soon! Current progress level is: 75%.
                    </p>
                  </div>
                </div>
                <div className="search-button">
                  <button
                    onClick={() => {
                      this.renderSearch();
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            ) : (
              <div className="crypto-page-cont">
                <div className="search-button">
                  <button
                    onClick={() => {
                      this.renderSearch();
                    }}
                  >
                    Search
                  </button>
                </div>
                <div className="shares-modal-wrapper">
                  <div className="shares-modal">
                    <FaTimes
                      className="exit"
                      onClick={() => {
                        this.showModal();
                      }}
                    />
                    <div className="title-wrapper">
                      <h3 className="title">Add Owned Shares</h3>
                      <p className="share-sym">
                        You are currently adding shares of{" "}
                        <span className="symbol">
                          {this.state.cryptoSymbol}
                        </span>
                      </p>
                      <p className="notice">
                        To edit share amount of an existing account crypto,
                        please visit account settings
                      </p>
                    </div>
                    <div className="shares-form">
                      <label>Shares</label>
                      <input
                        type="shares"
                        onChange={this.onChange}
                        value={this.state.shareCount}
                        id="shareCount"
                      ></input>
                      <button
                        className="submit-shares"
                        onClick={() => {
                          this.addShares(
                            this.state.cryptoSymbol,
                            this.state.cryptoName,
                            this.state.shareCount
                          );
                        }}
                      >
                        Add Shares
                      </button>
                    </div>
                  </div>
                </div>
                <div className="info">
                  <div className="title-wrapper">
                    <h2 className="crypto">{this.state.cryptoName}</h2>
                    <div className="share-btn-wrapper">
                      <button
                        className="share-btn"
                        onClick={() => {
                          this.showModal();
                        }}
                      >
                        Click here to add owned shares
                      </button>
                    </div>
                    <h4 className="crypto-symbol">{this.state.cryptoSymbol}</h4>
                  </div>
                  <hr className="divide-line" />
                  <div className="data-wrapper">
                    <div className="graph-wrapper">
                      <div className="graph-loader">
                        <FaHammer className="hammer" />
                        <p className="loading-text">Building graph...</p>
                      </div>
                      <p className="graph-title">5 Year History</p>
                      <div className="graph">
                        {this.state.graph ? (
                          <ResponsiveLine
                            key={""}
                            data={this.state.graphData}
                            margin={{
                              top: 35,
                              right: 45,
                              bottom: 50,
                              left: 60,
                            }}
                            xScale={{ type: "point" }}
                            yScale={{
                              type: "linear",
                              min: "auto",
                              max: "auto",
                              stacked: true,
                              reverse: false,
                            }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={null}
                            axisLeft={{
                              orient: "left",
                              tickSize: 5,
                              tickPadding: 5,
                              tickRotation: 0,
                              legend: "PRICE",
                              legendOffset: -40,
                              legendPosition: "middle",
                            }}
                            enableGridX={false}
                            enableGridY={false}
                            enablePoints={false}
                            enableCrosshair={false}
                            colors={{ scheme: "nivo" }}
                            pointSize={10}
                            pointColor={{ theme: "background" }}
                            pointBorderWidth={2}
                            pointBorderColor={{ from: "serieColor" }}
                            pointLabel="y"
                            pointLabelYOffset={-12}
                            useMesh={true}
                          />
                        ) : null}
                      </div>
                    </div>

                    <div className="current-info">
                      <div className="price-loader">
                        <FaDollarSign className="dollar" />
                        <p className="loading-text">Updating Data...</p>
                      </div>
                      <p className="data-title">Real-Time Financial Data</p>
                      <ul className="data-list">
                        <li className="current price">
                          Current Price
                          <span className="data">
                            $ {this.state.currentPrice}
                          </span>
                        </li>
                        <li className="current temp">
                          Enterprise Value
                          <span className="data">
                            $ {this.state.enterpriseValue}
                          </span>
                        </li>
                        <li className="current temp">
                          Outstanding Shares
                          <span className="data">
                            {this.state.outstandingShares}
                          </span>
                        </li>
                        <li className="current temp">
                          Earnings Per Share
                          <span className="data">$ {this.state.eps}</span>
                        </li>
                        <li className="current temp">
                          Price-to-Earnings Ratio
                          <span className="data">{this.state.pe}</span>
                        </li>
                        <li className="current reccomendation">
                          reccomendation
                          <span className="data">{this.state.reccKey}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activity: state,
    error: state.error,
  };
};

export default connect(mapStateToProps, { fetchSingleCrypto })(SearchCrypto);
